module.exports = __webpack_public_path__ + "img/user-icon.45126c74.jpg";